module.exports = __webpack_public_path__ + "static/media/ken.e46c4856.svg";